/**
 * An Enum of all available apps on the system
 */
const Apps = {
    AddonServices: 'addon-services',
    Api: 'api',
    AutomaticCleanup: 'automatic-cleanup',
    Billy: 'billy',
    BookingStatus: 'booking-status',
    ClientLogin: 'client-login',
    Consent: 'consent',
    CustomClientFields: 'custom-client-fields',
    Danmark: 'danmark',
    Dinero: 'dinero',
    DiscountCodes: 'discount-codes',
    Ean: 'ean',
    EasyPay: 'easy-pay',
    Economic: 'economic',
    Events: 'events',
    FacebookClientLogin: 'facebook-client-login',
    Fiken: 'fiken',
    Giftcards: 'giftcards',
    GoogleAnalytics: 'google-analytics',
    GoogleCalendar: 'google-calendar',
    Journal: 'journal',
    Mailchimp: 'mailchimp',
    OnlineBooking: 'online-booking',
    OnlineMeetings: 'online-meetings',
    PaymentRates: 'payment-rates',
    Reports: 'reports',
    SecureMessages: 'messaging',
    Surveys: 'surveys',
    ClientTags: 'client-tags',
    TranslationBeta: 'translation-beta',
    TwoFactorAuth: 'two-factor-auth',
    UserManagement: 'user-management',
    Vouchers: 'vouchers',
    WaitingList: 'waiting-list',
    Zapier: 'zapier',
    OnlineCourses: 'online-courses',
    Mobilepay: 'mobilepay',
    Zettle: 'zettle',
    Ehf: 'ehf',
    Fortnox: 'fortnox',
//--- New App Enum ---// <--- DO NOT REMOVE THIS LINE
}

export default Apps;